/** Survives ClinicPetDetails remounts during tab switches; reset on leaving base route. */
let baseFetchKey = null;
let overviewFetchKey = null;
let prescriptionsFetchKey = null;
let diagnosticsFetchKey = null;
let billingFetchKey = null;

export const getBaseFetchKey = () => baseFetchKey;
export const setBaseFetchKey = (key) => {
  baseFetchKey = key;
};

export const getOverviewFetchKey = () => overviewFetchKey;
export const setOverviewFetchKey = (key) => {
  overviewFetchKey = key;
};

export const getPrescriptionsFetchKey = () => prescriptionsFetchKey;
export const setPrescriptionsFetchKey = (key) => {
  prescriptionsFetchKey = key;
};

export const getDiagnosticsFetchKey = () => diagnosticsFetchKey;
export const setDiagnosticsFetchKey = (key) => {
  diagnosticsFetchKey = key;
};

export const getBillingFetchKey = () => billingFetchKey;
export const setBillingFetchKey = (key) => {
  billingFetchKey = key;
};

export const resetClinicPetDetailsFetchKeys = () => {
  baseFetchKey = null;
  overviewFetchKey = null;
  prescriptionsFetchKey = null;
  diagnosticsFetchKey = null;
  billingFetchKey = null;
};
